/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IMedicine } from 'app/shared/model/medicine.model';
import { IPatientProcedureOrder } from 'app/shared/model/patient-procedure-order.model';

export interface IPatientProcedureMedicine {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  quantity?: number;
  medicine?: IMedicine;
  order?: IPatientProcedureOrder;
}

export const defaultValue: Readonly<IPatientProcedureMedicine> = {
  active: false,
};
